import { cva } from 'class-variance-authority';

export const raceSummaryCardVariants = cva(
  'box-border w-full min-w-0 max-w-full cursor-pointer rounded-3xl border border-border bg-muted py-4 px-6 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring'
);

export const raceSummaryProportionBarSpacingVariants = cva('mb-8');

export const raceSummaryStatLabelVariants = cva(
  'text-[11px] font-semibold leading-none tracking-wider uppercase text-muted-foreground',
  {
    variants: {
      display: {
        inline: '',
        block: 'block',
      },
    },
    defaultVariants: {
      display: 'inline',
    },
  }
);

export const raceSummaryStatCounterVariants = cva('text-xl font-bold leading-none', {
  variants: {
    tone: {
      participants: 'text-foreground',
      onCourse: 'text-proportion-bar-on-course',
      finished: 'text-proportion-bar-finished',
    },
  },
});

export const raceSummaryFootnoteVariants = cva(
  'mt-8 text-[12px] font-normal italic leading-normal text-[#5c6166]'
);
